import { Injectable } from "@angular/core";
import { ApplicationHttpService } from "../../../core/services/application-http.service";
import { map, Observable } from "rxjs";
import { BackOfficePaymentResponse, Payment, PaymentAppFilterValues, PaymentAppRequest, PaymentAppResponse } from "../models/payment.model";

@Injectable({ providedIn: 'root' })
export class PaymentAppService {
    constructor(private http: ApplicationHttpService) {}

    getList(request: PaymentAppRequest): Observable<PaymentAppResponse> {
        return this.http.get<PaymentAppResponse>(`back-office-payment/list`, request.params());
    }

    getFilterValues(): Observable<PaymentAppFilterValues> {
        return this.http.get<PaymentAppFilterValues>(`back-office-payment/filter-values`);
    }

    /**
     * DR-835 — there's no dedicated "payment by application" endpoint yet, so this reuses
     * `back-office-payment/list`'s `search` param (LIKE match on applicationId/invoiceNumber/
     * epayReference/payerEmail) and filters client-side down to an exact applicationId match,
     * keeping the newest one (default sort is `createdAt,desc`).
     */
    getByApplicationId(applicationId: string): Observable<Payment | null> {
        const request = new PaymentAppRequest();
        request.search = applicationId;
        request.size = 5;

        return this.getList(request).pipe(
            map(response => response.content.find(item => item.applicationId === applicationId) ?? null)
        );
    }

    /** DR-832 / US-33a. Path param is the applicationId (e.g. "REG-5824"), not the numeric payment id. */
    getDetails(applicationId: string): Observable<BackOfficePaymentResponse> {
        return this.http.get<BackOfficePaymentResponse>(`back-office-payment/${applicationId}`);
    }

    /** Generic document download by id — same endpoint used elsewhere in front-int (see application-document.service.ts). */
    downloadDocument(documentId: number): Observable<Blob> {
        return this.http.getFile(`document/download/${documentId}`);
    }
}